const noNextCallData = {
  cursor: null,
  size: null,
  query: null,
  promise: null
};
export class NextCallData {
  constructor() {
    this._nextCallData = noNextCallData;
  }
  getPromise() {
    return this._nextCallData.promise;
  }
  set(paging, promise, query, folderId) {
    if (query === void 0) {
      query = null;
    }
    if (folderId === void 0) {
      folderId = null;
    }
    const {
      cursor = null,
      size = null
    } = paging;
    this._nextCallData = {
      cursor,
      size: size && Number(size),
      query,
      promise,
      folderId
    };
  }
  reset() {
    return this._nextCallData = noNextCallData;
  }
  getPromiseAndReset() {
    const promise = this.getPromise();
    this.reset();
    return promise;
  }
  isNextCallDataExists(paging, query, folderId) {
    if (query === void 0) {
      query = null;
    }
    if (folderId === void 0) {
      folderId = null;
    }
    const {
      cursor = null,
      size = null
    } = paging;
    const {
      cursor: nextCursor,
      size: nextSize,
      query: nextQuery,
      promise: nextPromise,
      folderId: nextFolderId
    } = this._nextCallData;
    return Boolean(nextCursor === cursor && nextSize === (size && Number(size)) && query === nextQuery && nextPromise && folderId === nextFolderId);
  }
}